module.exports = __webpack_public_path__ + "img/edit.41f1e245.svg";